import React from 'react';
import { UserPlus } from 'lucide-react';

const VALID_SOURCES = [
  "Audria Richmond®",
  "UnCloned® Free Community",
  "UnCloned® Coaching Client",
  "UnCloned® Consulting Client",
  "Instagram",
  "Facebook",
  "LinkedIn",
  "YouTube",
  "TikTok",
  "Google Search",
  "Email Newsletter",
  "Podcast",
  "Live Event or Conference",
  "Webinar or Challenge",
  "Friend or Referral",
  "Facebook Ad",
  "Instagram Ad",
  "Other",
  "Unknown / Not Provided"
];

const SOURCE_ICONS = {
  "Audria Richmond®": "👑",
  "UnCloned® Free Community": "🐑",
  "UnCloned® Coaching Client": "🎯",
  "UnCloned® Consulting Client": "💼",
  "Instagram": "📸",
  "Facebook": "📘",
  "LinkedIn": "💼",
  "YouTube": "▶️",
  "TikTok": "🎵",
  "Google Search": "🔍",
  "Email Newsletter": "📧",
  "Podcast": "🎙️",
  "Live Event or Conference": "🎤",
  "Webinar or Challenge": "💻",
  "Friend or Referral": "🤝",
  "Facebook Ad": "📢",
  "Instagram Ad": "📢",
  "Other": "✨"
};

const ReferralSourceChart = ({ data }) => {
  if (!data || !data.referrals || data.referrals.length === 0) {
    return (
      <div className="bg-gradient-to-br from-[#2D063E] to-[#1a0527] border border-[#4A0A66]/50 rounded-xl p-5">
        <h3 className="text-base font-semibold text-white mb-3 flex items-center gap-2">
          <UserPlus className="w-5 h-5 text-[#FF7901]" />
          How Users Found Us
        </h3>
        <p className="text-sm text-[#FDF2F8]/50 text-center py-6">No referral data yet</p>
      </div>
    );
  }
  
  const filteredReferrals = data.referrals.filter(r => VALID_SOURCES.includes(r.source));
  const maxCount = Math.max(...filteredReferrals.map(r => r.count), 1);
  
  return (
    <div className="bg-gradient-to-br from-[#2D063E] to-[#1a0527] border border-[#4A0A66]/50 rounded-xl p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-semibold text-white flex items-center gap-2">
          <UserPlus className="w-5 h-5 text-[#FF7901]" />
          How Users Found Us
        </h3>
        <span className="text-sm text-[#FF7901] font-medium">{data.response_rate}% response rate</span>
      </div>
      
      <div className="space-y-3">
        {filteredReferrals.slice(0, 10).map((item) => (
          <div key={item.source} className="bg-[#1a0527]/50 rounded-lg p-3">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2 flex-1 min-w-0">
                <span className="text-xl flex-shrink-0">{SOURCE_ICONS[item.source] || "📍"}</span>
                <span className="text-sm text-[#FDF2F8] font-medium">
                  {item.source}
                </span>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-sm text-[#FDF2F8]/70">{item.count} users</span>
                <span className="text-sm text-[#FF7901] font-bold">{item.percentage}%</span>
              </div>
            </div>
            <div className="w-full h-2 bg-[#4A0A66] rounded-full overflow-hidden">
              <div 
                className="h-full bg-gradient-to-r from-[#FF7901] to-[#df1283] rounded-full transition-all duration-500"
                style={{ width: `${(item.count / maxCount) * 100}%` }}
              />
            </div>
          </div>
        ))}
      </div>
      
      {data.other_responses && data.other_responses.length > 0 && (
        <div className="mt-4 pt-4 border-t border-[#4A0A66]/50">
          <p className="text-sm text-[#FDF2F8]/60 mb-2 font-medium">"Other" responses:</p>
          <div className="flex flex-wrap gap-2">
            {data.other_responses.slice(0, 5).map((response, idx) => (
              <span key={`other-${response}-${idx}`} className="text-sm bg-[#4A0A66]/50 text-[#FDF2F8] px-3 py-1 rounded-full">
                {response}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export { VALID_SOURCES, SOURCE_ICONS };
export default ReferralSourceChart;
